// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import { Input } from "antd";
// import { MailFilled, LockFilled } from "@ant-design/icons";
// import LoginBackgroundImage from "../../Assets/GodrejLOGO.png";
// import useInputs from "../../customhooks/useInputs";
// import CustomButton from "../../common/button/CustomButton";
// import { loginFetch } from "../../services/Login";
// import { useMsal } from "@azure/msal-react";
// import { loginRequest } from "../../msalConfig"; // Import scopes for login request
// import { FaMicrosoft } from "react-icons/fa"; // Import Microsoft icon

// function Login() {
//   let email = useInputs("");
//   let password = useInputs("");
//   const [btndisable, setBtnDisable] = useState(false);
//   const navigate = useNavigate();
//   const { instance } = useMsal(); // Use MSAL instance

//   const inputValidations = () => {
//     let emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
//     let passwordRegex =
//       /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
//     if (email.value === "" || !emailRegex.test(email.value)) {
//       return { value: false, message: "Recheck the email entered" };
//     } else if (password.value === "" || !passwordRegex.test(password.value)) {
//       return {
//         value: false,
//         message:
//           "Password must be 8 characters long or more and include one Uppercase, one Lowercase, one Digit, and a special Character.",
//       };
//     }
//   };

//   const handleLogin = async () => {
//     let responseOfValidation = inputValidations();
//     if (responseOfValidation?.value === false) {
//       toast(responseOfValidation.message);
//       return;
//     }
//     let data = await loginFetch({
//       email: email.value,
//       password: password.value,
//     });
//     if (data === 200) {
//       toast.success("Login Successful");
//       setTimeout(() => {
//         localStorage.setItem("path", "/home");
//         navigate("/home");
//       }, 2000);
//     } else {
//       toast.error(data.message);
//       setBtnDisable(false);
//     }
//   };

//   const handleSSOLogin = () => {
//     instance
//       .loginPopup(loginRequest) // Initiates Microsoft login popup
//       .then(async (response) => {
//         const ssoToken = response.accessToken;
//         // console.log(response);
//         // toast.success("Login Successful with Microsoft!");
//         // localStorage.setItem("msal-token", response.accessToken); // Store token if needed
//         // navigate("/home"); // Navigate to the home page
//         let data = await loginFetch({
//           ssoToken: JSON.stringify({ ssoToken }),
//         });
//         if (data === 200) {
//           toast.success("Login Successful");
//           setTimeout(() => {
//             localStorage.setItem("path", "/home");
//             navigate("/home");
//           }, 2000);
//         } else {
//           toast.error(data.message);
//           setBtnDisable(false);
//         }
//       })
//       .catch((error) => {
//         console.error(error);
//         toast.error("SSO Login failed. Please try again.");
//       });
//   };

//   return (
//     <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-50 to-blue-100">
//       {/* Logo */}

//       {/* Login Form */}
//       <div className="w-full max-w-sm bg-white p-8 rounded-3xl shadow-lg transform transition-all duration-300 hover:scale-105">
//         <div className="flex justify-center mb-6">
//           <img
//             className="w-32 h-auto sm:w-48 object-contain"
//             src={LoginBackgroundImage}
//             alt="Logo"
//           />
//         </div>
//         <div className="text-center mb-6">
//           <span className="text-2xl font-extrabold text-gray-800">
//             Welcome Back!
//           </span>
//           <p className="text-gray-500">Log in to your account</p>
//         </div>

//         {/* Email Input */}
//         <div className="mb-3">
//           <label className="block text-gray-600 font-semibold mb-2">
//             Email Address
//           </label>
//           <Input
//             required
//             prefix={<MailFilled />}
//             placeholder="Enter Your Email"
//             value={email.value}
//             onChange={email.onChange}
//             className="w-full px-4 py-3 rounded-lg shadow-sm border border-gray-300 focus:ring-blue-500 focus:border-blue-500 transition"
//           />
//         </div>

//         {/* Password Input */}
//         <div className="mb-3">
//           <label className="block text-gray-600 font-semibold mb-2">
//             Password
//           </label>
//           <Input.Password
//             required
//             prefix={<LockFilled />}
//             placeholder="Enter Your Password"
//             value={password.value}
//             onChange={password.onChange}
//             className="w-full px-4 py-3 rounded-lg shadow-sm border border-gray-300 focus:ring-blue-500 focus:border-blue-500 transition"
//             visibilityToggle
//           />
//         </div>

//         {/* Buttons */}
//         <div className="flex items-center justify-between mb-5">
//           <CustomButton
//             onClick={handleLogin}
//             disabled={btndisable ? btndisable : false}
//             className="bg-gradient-to-r from-blue-400 to-blue-600 text-white font-bold py-3 px-6 rounded-full shadow-md hover:from-blue-500 hover:to-blue-700 transition-all duration-300"
//           >
//             Let's Login
//           </CustomButton>
//           <a
//             href="/forgotpassword"
//             className="text-sm text-blue-500 hover:text-blue-600 transition-colors duration-300"
//           >
//             Forgot Password?
//           </a>
//         </div>

//         {/* Divider with OR */}
//         <div className="flex items-center justify-center my-2">
//           <span className="h-px w-full bg-gray-300"></span>
//           <span className="px-3 text-gray-500 text-sm font-medium">OR</span>
//           <span className="h-px w-full bg-gray-300"></span>
//         </div>

//         {/* SSO Button */}
//         <div className="flex justify-center mb-4">
//           <button
//             onClick={handleSSOLogin}
//             className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-full shadow-md flex items-center justify-center transition-all duration-300"
//           >
//             <FaMicrosoft className="text-2xl mr-2" />
//             Login with Microsoft
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Login;
// Login.js
import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Input } from "antd";
import { MailFilled, LockFilled } from "@ant-design/icons";
import LoginBackgroundImage from "../../Assets/GodrejLOGO.png";
import useInputs from "../../customhooks/useInputs";
import CustomButton from "../../common/button/CustomButton";
import { loginFetch } from "../../services/Login";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../msalConfig"; // Import scopes for login request
import { FaMicrosoft } from "react-icons/fa";

function Login() {
  let email = useInputs("");
  let password = useInputs("");
  const [btndisable, setBtnDisable] = useState(false);
  const navigate = useNavigate();
  const { instance } = useMsal(); // Use MSAL instance

  const inputValidations = () => {
    let emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    let passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (email.value === "" || !emailRegex.test(email.value)) {
      return { value: false, message: "Recheck the email entered" };
    } else if (password.value === "" || !passwordRegex.test(password.value)) {
      return {
        value: false,
        message:
          "Password must be 8 characters long or more and include one Uppercase, one Lowercase, one Digit, and a special Character.",
      };
    }
  };

  const handleLogin = async () => {
    let responseOfValidation = inputValidations();
    if (responseOfValidation?.value === false) {
      toast(responseOfValidation.message);
      return;
    }
    let data = await loginFetch({
      email: email.value,
      password: password.value,
    });
    if (data === 200) {
      toast.success("Login Successful");
      setTimeout(() => {
        localStorage.setItem("path", "/home");
        navigate("/home");
      }, 2000);
    } else {
      toast.error(data.message);
      setBtnDisable(false);
    }
  };

  // const handleOIDCLogin = () => {
  //   instance
  //     .loginPopup(loginRequest) // Initiates OIDC login popup
  //     .then(async (response) => {
  //       const oidcToken = response.accessToken;
  //       let data = await loginFetch({
  //         oidcToken: JSON.stringify({ oidcToken }),
  //       });
  //       if (data === 200) {
  //         toast.success("OIDC Login Successful");
  //         setTimeout(() => {
  //           localStorage.setItem("path", "/home");
  //           navigate("/home");
  //         }, 2000);
  //       } else {
  //         toast.error(data.message);
  //         setBtnDisable(false);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //       toast.error("OIDC Login failed. Please try again.");
  //     });
  // };
  const handleOIDCLogin = async () => {
    instance.loginPopup().catch((e) => {
      console.log("MSAL REACT LOGIN ----> ", e);
    });
    // try {
    //   const res = await axios.get(
    //     "https://godrej.app-assertai.com:5000/Auth/loginwithsso"
    //   );
    //   // Send token to backend for verification
    //   // const res = await fetch("https://godrej.app-assertai.com:5000/Auth/loginwithsso", {
    //   //   method: "POST",
    //   //   headers: {
    //   //     "Content-Type": "application/json",
    //   //   },
    //   //   body: JSON.stringify({ oidcToken }),
    //   // });
    //   console.log("Response is ---> ", res);
    //   const data = await res.json();

    //   if (res.ok) {
    //     toast.success("OIDC Login Successful");
    //     setTimeout(() => {
    //       localStorage.setItem("path", "/home");
    //       navigate("/home");
    //     }, 2000);
    //   } else {
    //     toast.error(data.message);
    //     setBtnDisable(false);
    //   }
    // } catch (error) {
    //   console.error("OIDC Login failed", error);
    //   toast.error("OIDC Login failed. Please try again.");
    // }
    // instance
    //   .loginPopup(loginRequest)
    //   .then(async (response) => {
    //     const oidcToken = response.accessToken;

    //   })
    //   .catch((error) => {
    //     console.error(error);
    //     toast.error("OIDC Login failed. Please try again.");
    //   });
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-50 to-blue-100">
      {/* Logo */}
      <div className="w-full max-w-sm bg-white p-8 rounded-3xl shadow-lg transform transition-all duration-300 hover:scale-105">
        <div className="flex justify-center mb-6">
          <img
            className="w-32 h-auto sm:w-48 object-contain"
            src={LoginBackgroundImage}
            alt="Logo"
          />
        </div>
        <div className="text-center mb-6">
          <span className="text-2xl font-extrabold text-gray-800">
            Welcome Back!
          </span>
          <p className="text-gray-500">Log in to your account</p>
        </div>

        {/* Email Input */}
        <div className="mb-3">
          <label className="block text-gray-600 font-semibold mb-2">
            Email Address
          </label>
          <Input
            required
            prefix={<MailFilled />}
            placeholder="Enter Your Email"
            value={email.value}
            onChange={email.onChange}
            className="w-full px-4 py-3 rounded-lg shadow-sm border border-gray-300 focus:ring-blue-500 focus:border-blue-500 transition"
          />
        </div>

        {/* Password Input */}
        <div className="mb-3">
          <label className="block text-gray-600 font-semibold mb-2">
            Password
          </label>
          <Input.Password
            required
            prefix={<LockFilled />}
            placeholder="Enter Your Password"
            value={password.value}
            onChange={password.onChange}
            className="w-full px-4 py-3 rounded-lg shadow-sm border border-gray-300 focus:ring-blue-500 focus:border-blue-500 transition"
            visibilityToggle
          />
        </div>

        {/* Login Button */}
        <div className="flex items-center justify-between mb-5">
          <CustomButton
            onClick={handleLogin}
            disabled={btndisable}
            className="bg-gradient-to-r from-blue-400 to-blue-600 text-white font-bold py-3 px-6 rounded-full shadow-md hover:from-blue-500 hover:to-blue-700 transition-all duration-300"
          >
            Let's Login
          </CustomButton>
          <a
            href="/forgotpassword"
            className="text-sm text-blue-500 hover:text-blue-600 transition-colors duration-300"
          >
            Forgot Password?
          </a>
        </div>

        {/* Divider */}
        <div className="flex items-center justify-center my-2">
          <span className="h-px w-full bg-gray-300"></span>
          <span className="px-3 text-gray-500 text-sm font-medium">OR</span>
          <span className="h-px w-full bg-gray-300"></span>
        </div>

        {/* OIDC Button */}
        <div className="flex justify-center mb-4">
          <button
            onClick={handleOIDCLogin}
            className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-6 rounded-full shadow-md flex items-center justify-center transition-all duration-300"
          >
            <FaMicrosoft className="text-2xl mr-2" />
            Login with OIDC
          </button>
        </div>
      </div>
    </div>
  );
}

export default Login;
